const record = (value: unknown): Record<string, unknown> =>
  value !== null && typeof value === 'object' && !Array.isArray(value) ? (value as Record<string, unknown>) : {};
const messages = (value: unknown): string[] => (Array.isArray(value) ? value.filter((entry): entry is string => typeof entry === 'string') : []);
export class ReportDefinitionApiError extends Error {
  readonly status: number;
  readonly fields: Readonly<Record<string, string>>;
  readonly reasons: readonly string[];
  constructor(status: number, message: string, fields: Readonly<Record<string, string>> = {}, reasons: readonly string[] = []) {
    super(message);
    this.name = 'ReportDefinitionApiError';
    this.status = status;
    this.fields = fields;
    this.reasons = reasons;
  }
}
export const definitionApiError = (status: number, body: unknown): ReportDefinitionApiError => {
  const detail = record(body).detail;
  const value = record(detail);
  const fields = Object.fromEntries(
    Object.entries(record(value.parameter_errors)).filter((entry): entry is [string, string] => typeof entry[1] === 'string')
  );
  const reasons = messages(value.unavailable_reasons);
  const validation = Array.isArray(detail) ? detail.map((item) => record(item).msg).filter((item): item is string => typeof item === 'string') : [];
  const message =
    typeof detail === 'string'
      ? detail
      : typeof value.message === 'string'
      ? value.message
      : typeof value.error === 'string'
      ? value.error
      : validation.join('; ') || reasons.join('; ') || Object.values(fields).join('; ') || `Report request failed (${status})`;
  return new ReportDefinitionApiError(status, message, fields, reasons);
};
